import { handleDay, handleLine, handleGroup, handleSetInitialState } from './actions';

export const DAYS_IDS_TO_APPROVE_OR_REJECT_ACTIONS = Object.freeze({
  HANDLE_DAY: 'HANDLE_DAY',
  HANDLE_LINE: 'HANDLE_LINE',
  HANDLE_GROUP: 'HANDLE_GROUP',
  HANDLE_CHECK_ALL: 'HANDLE_CHECK_ALL',
  RESET_STATE: 'RESET_STATE',
  SET_INITIAL_DATA: 'SET_INITIAL_DATA'
});

export const daysIDsToApproveOrRejectReducer = (state, { type, payload }) => {
  if (type === DAYS_IDS_TO_APPROVE_OR_REJECT_ACTIONS.HANDLE_DAY) return handleDay(state, payload);
  if (type === DAYS_IDS_TO_APPROVE_OR_REJECT_ACTIONS.HANDLE_LINE) return handleLine(state, payload);
  if (type === DAYS_IDS_TO_APPROVE_OR_REJECT_ACTIONS.HANDLE_GROUP)
    return handleGroup(state, payload);
  if (type === DAYS_IDS_TO_APPROVE_OR_REJECT_ACTIONS.RESET_STATE) return new Set();
  if (type === DAYS_IDS_TO_APPROVE_OR_REJECT_ACTIONS.SET_INITIAL_DATA)
    return handleSetInitialState(state, payload);

  return state;
};
